module.exports = __webpack_public_path__ + "img/avatar.a2aa3dd9.png";